import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";

// Pages
import Home from "./pages/Home";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";

// Services Pages
import AllServices from "./pages/services/AllServices"; // <-- NEW
import OrthopaedicPT from "./pages/services/OrthopaedicPT";
import PostSurgicalPT from "./pages/services/PostSurgicalPT";
import NeuroPT from "./pages/services/NeuroPT";
import PreoperativePrehab from "./pages/services/PreoperativePrehab";

// About Pages
import AboutUs from "./pages/about/AboutUs";
import Team from "./pages/about/Team";

// Patient Info Pages
import WhatToExpect from "./pages/patientInfo/WhatToExpect";
import PatientPortal from "./pages/patientInfo/PatientPortal";
import FAQ from "./pages/patientInfo/FAQ";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        {/* Home */}
        <Route path="/" element={<Home />} />

        {/* Services - overview page */}
        <Route path="/services" element={<AllServices />} />

        {/* Individual service detail pages */}
        <Route path="/services/orthopaedic" element={<OrthopaedicPT />} />
        <Route path="/services/post-surgical" element={<PostSurgicalPT />} />
        <Route path="/services/neuro" element={<NeuroPT />} />
        <Route path="/services/preoperative" element={<PreoperativePrehab />} />

        {/* About */}
        <Route path="/about/about-us" element={<AboutUs />} />
        <Route path="/about/team" element={<Team />} />

        {/* Patient Info */}
        <Route path="/patient-info/what-to-expect" element={<WhatToExpect />} />
        <Route path="/patient-info/patient-portal" element={<PatientPortal />} />
        <Route path="/patient-info/faq" element={<FAQ />} />

        {/* Blog */}
        <Route path="/blog" element={<Blog />} />

        {/* Contact */}
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
